import cleanObject from '@/utils/helpers/cleanObject';

export default {
  namespaced: true,

  state: () => ({
    recentlyViewed: [],
    recommendations: [],
    slots: {},
  }),

  mutations: {
    setGallery(state, { galleryName, gallery = [] } = {}) {
      state[galleryName] = gallery;
    },

    setSlotGallery(state, { galleryName, gallery = {} } = {}) {
      state.slots[galleryName] = gallery;
    },
  },

  actions: {
    async loadRecentlyViewed({ commit }) {
      const result = await this.$api.loadRecentlyViewedProducts();

      if (result?.length) {
        commit('setGallery', {
          galleryName: 'recentlyViewed',
          gallery: result,
        });
      }
    },

    async loadSlot({ commit }, { slot, categoryId, catalogType }) {
      if (!slot) {
        throw new Error('loadSlot не передан аргумент slot');
      }

      const result = await this.$apiBFF
        .fetchRecommendations(cleanObject(
          {
            slots: [slot],
            type: catalogType,
            categoryId,
            withCatalogProducts: !categoryId,
          },
        ));

      if (result[slot]) {
        const [data] = result[slot];
        commit('setSlotGallery', {
          galleryName: slot,
          gallery: data,
        });
      }
    },

    async loadRecommendations({ commit }, productIds = []) {
      if (!productIds.length) {
        throw new Error('loadRecommendations не передан аргумент productIds');
      }

      const result = await this.$api.loadRecommendationsProducts(productIds);

      if (result?.length) {
        commit('setGallery', {
          galleryName: 'recommendations',
          gallery: result,
        });
      }
    },
  },
};
